import { ProductionTechnologiesRecipes } from "src/app/services/service/DataProviders/ProductionTechnologiesRecipes";
import * as _ from "lodash";
import { take } from "rxjs/internal/operators/take";
import * as moment from "moment";
import createGraph from "ngraph.graph";
import RecipeNode from "./recipe-node";
import { LogisticsInventoryCurrentBalances } from "src/app/services/service/DataProviders/LogisticsInventoryCurrentBalances";

export class RecipeTree {
  private recepieService: ProductionTechnologiesRecipes;
  private availabilityService: LogisticsInventoryCurrentBalances;
  public tree;
  public quantity;
  public maxLevel = 0;
  public rootPONumber = null;
  public rootPO = null;

  constructor(recipieService, availabilityService) {
    this.tree = createGraph();
    this.recepieService = recipieService;
    this.availabilityService = availabilityService;
  }

  public setRootPo(po) {
    if(_.isNull(this.rootPONumber) && _.has(po, 'DocumentNo')) {
      this.rootPONumber = _.get(po, 'DocumentNo')
      this.rootPO = po;
    }
  }

  public getRootPONumber() {
    return this.rootPONumber;
  }

  public async init(product, quantity) {
    this.quantity = quantity;
    await this.buildTree(product, 0, quantity, 1, product.MeasurementUnit);
    await this.getMaxLevel();
  }

  public async buildTree(product, level, quantity, quantityFromReceipt, measurementUnit) {
    let masterNode = new RecipeNode(
      level,
      product,
      quantity,
      quantityFromReceipt,
      this.recepieService,
      this,
      measurementUnit,
      this.availabilityService,
    );

    let masterNodeRes = await masterNode.init();
    if (masterNodeRes === false) {
      return null;
    }

    this.tree.addNode(masterNode);
    let ingredients = masterNode.defaultTechnologyIngredients;

    for (let i = 0; i < ingredients.length; i++) {
      const theIngredient = ingredients[i];

      if(!_.has(theIngredient, 'UsageQuantity.Value')) {
        this.availabilityService.displayMessage({
          type: 'error',
          title: 'Грешка при взимане на технология',
          text: `В техлология за "${masterNode.name}" липсва количество за съставка "${theIngredient.Material.Name.BG}"`
      });
        throw new Error('Липсва количество в технология: ' + masterNode.defaultTechnologyId);
      }

      let ingredientNode = await this.buildTree(
        theIngredient.Material,
        level + 1,
        quantityFromReceipt*quantity,
        parseFloat(theIngredient.UsageQuantity.Value),
        theIngredient.UsageUnit
      );

      if (_.isNull(ingredientNode)) {
        continue;
      }

      this.tree.addNode(ingredientNode);
      this.tree.addLink(masterNode, ingredientNode);
    }

    return masterNode;
  }

  private async getMaxLevel() {
    let self = this;
    self.tree.forEachNode(function (node) {
      if (node.id.level > self.maxLevel) {
        self.maxLevel = node.id.level;
      }
    });

    return self.maxLevel;
  }

  public getLinkedNodes(node) {
    let nodes = [];
    this.tree.forEachLinkedNode(node, function(linkedNode, link){
      nodes.push(linkedNode.id);
    });

    return nodes;
  }

  public getNodesOnLevel(level) {
    let nodes = [];
    this.tree.forEachNode(function (node) {
      // console.log(node.id.level, level);
      if (node.id.level == level) {
        nodes.push(node.id);
      }
    });
    return nodes;
  }

  public getSuccessors(node) {
    let nodes = [];
    this.tree.forEachLinkedNode(node, function(linkedNode, link){
      if(node.level < linkedNode.id.level) {
        nodes.push(linkedNode.id);
      }
    });
    return nodes;
  }

  public getPredecessor(node) {
    let nodes = [];
    this.tree.forEachLinkedNode(node, function(linkedNode, link){
      if(node.level > linkedNode.id.level) {
        nodes.push(linkedNode.id);
      }
    });
    return nodes;
  }

  public getProductName() {
    let nodesWithLevel0 = this.getNodesOnLevel(0);
    let master = nodesWithLevel0[0];
    return master.getProductName();
  }

  public getAllNodes() {
    let nodes = [];
    this.tree.forEachNode(function (node) {
      nodes.push(node.id);
    });
    return nodes;
  }
}
